import React, { useCallback, useMemo, useState } from 'react';
import cx from 'classnames';

import { NotificationManager, SiteConfigManager } from '@atlas/core';
import { BasePopup, Button, Icon, Label } from '@atlas/ui';

import StaticBlock from 'common/StaticBlock/StaticBlock';
import { useIsRtl } from 'hooks/useIsRtl';

const AdultPopup = ({ data: { isForbidden, onError, onSuccess } = {}, id }) => {
  const [isForbiddenPopup, setForbiddenPopup] = useState(!!isForbidden);
  const staticBlock = SiteConfigManager.getConfig('config.config.general.popup18StaticBlock');
  const isRtl = useIsRtl();
  const classNames = useMemo(
    () => ({
      base: cx('messages-popup messages-popup-multi', {
        'messages-popup-multi-fullsize': isForbiddenPopup,
      }),
      content: cx('messages-popup__content messages-popup__content-multi', {
        'messages-popup__content-multi-center': isForbiddenPopup,
        'messages-popup__content-multi-padding': !isForbiddenPopup && staticBlock,
        'messages-popup__content-multi-rtl': isRtl,
      }),
    }),
    [isRtl, isForbiddenPopup],
  );

  const onSuccessHandler = useCallback(() => {
    NotificationManager.removeNotification(id);
    onSuccess();
  }, [id, onSuccess]);

  const onErrorHandler = useCallback(() => {
    setForbiddenPopup(true);
    onError();
  }, [onError]);

  return (
    <BasePopup className={classNames.base}>
      {isForbiddenPopup && (
        <div className={classNames.content}>
          <Icon height={48} name="verify" width={48} />
          <Label
            className="messages-popup__content-multi-title messages-popup__content-multi-label"
            message="adult_forbidden_title"
          />
          <Label
            className="messages-popup__content-multi-label"
            message="adult_forbidden_description"
          />
        </div>
      )}

      {!isForbiddenPopup && (
        <>
          <div className={classNames.content}>
            {!!staticBlock && (
              <StaticBlock
                options={{
                  source: staticBlock,
                }}
              />
            )}
          </div>

          <div className="messages-popup__control">
            <Button
              className="secondary big block"
              label="adult_no_button_name"
              onClick={onErrorHandler}
            />
            <Button
              className="primary big block"
              label="adult_yes_button_name"
              onClick={onSuccessHandler}
            />
          </div>
        </>
      )}
    </BasePopup>
  );
};

export default AdultPopup;
